import { FormRow, ObjectDataRecord } from '@types'

export const mapCoreKeysToFormKeys = (
  coreValues: ObjectDataRecord,
  fields: FormRow[]
): ObjectDataRecord => {
  const fieldsByCoreKey: Record<string, FormRow[]> = {}

  for (const field of fields) {
    const coreKey = field.value

    if (!coreKey) {
      continue
    }

    if (!fieldsByCoreKey[coreKey]) {
      fieldsByCoreKey[coreKey] = []
    }

    fieldsByCoreKey[coreKey].push(field)
  }

  const formRecord: ObjectDataRecord = {}

  for (const [key, value] of Object.entries(coreValues)) {
    const formFields = fieldsByCoreKey[key]

    if (!formFields?.length) {
      if (!(key in formRecord)) {
        formRecord[key] = value
      }
      continue
    }

    for (const formField of formFields) {
      formRecord[formField.code || key] = value
    }
  }

  return formRecord
}